import { apiClient } from ".";
import { useMutation } from "@tanstack/react-query";

export const startLogin = async () => {
  const response = await apiClient({
    url: `/auth/auth`,
    method: "POST",
    data: {
      authText: "Jag identifierar mig mot Sambla Group AB",
    },
  });
  return response.data;
};

export const useStartLogin = () =>
  useMutation({
    mutationFn: () => startLogin(),
  });
